/**
 * Factory for an empty preferred J-code / drug-name row.
 * @module createEmptyPreferredJcodeEntry
 */

import { PreferredJcodeEntry } from "../statusUpdateModal.types";

/**
 * Creates an empty preferred J-code entry with a unique row id.
 *
 * @return A blank {@link PreferredJcodeEntry}
 */
export const createEmptyPreferredJcodeEntry = (): PreferredJcodeEntry => ({
  id: crypto.randomUUID(),
  jCode: "",
  drugName: "",
});
